import React from 'react';
import { Col } from 'reactstrap';

/**
 * This is a custom column component that allows us to use an "xxl" breakpoint.
 * Cf. https://github.com/reactstrap/reactstrap/issues/297#issuecomment-273556116
 */
const CustomCol = (props) => {
  return (
    <Col widths={['xs', 'sm', 'md', 'lg', 'xl', 'xxl', 'xxxl']} {...props} />
  );
};

export default CustomCol;
